import PropTypes from 'prop-types';

import TextField from 'src/components/ui/TextField';
import DatePicker from 'src/components/ui/DatePicker';
import TimePicker from 'src/components/ui/TimePicker';
import Select from 'src/components/ui/Select';
import Autocomplete from 'src/components/ui/Autocomplete';
import RadioGroup from 'src/components/ui/RadioGroup';
import CheckboxGroup from 'src/components/ui/CheckboxGroup';
import TypedField from 'src/components/ui/TypedField';
import UploadField from 'src/components/ui/UploadField';
import RangeField from 'src/components/ui/RangeField';

import TextFieldCFormik from 'src/components/ui/TextField/connecotrs/TextFieldCFormik';
import DatePickerCFormik from 'src/components/ui/DatePicker/connectors/DatePickerCFormik';
import TimePickerCFormik from 'src/components/ui/TimePicker/connectors/TimePickerCFormik';
import SelectCFormik from 'src/components/ui/Select/connectors/SelectCFormik';
import AutocompleteCFormik from 'src/components/ui/Autocomplete/connectors/AutocompleteCFormik';
import RadioGroupCFormik from 'src/components/ui/RadioGroup/connectors/RadioGroupCFormik';
import CheckboxGroupCFormik from 'src/components/ui/CheckboxGroup/connectors/CheckboxGroupCFormik';
import TypedFieldCFormik from 'src/components/ui/TypedField/connectors/TypedFieldCFormik';
import UploadFieldCFormik from 'src/components/ui/UploadField/connectors/UploadFieldCFormik';
import RangeFieldCFormik from 'src/components/ui/RangeField/connectors/RangeFieldCFormik';

import { FORM_LINE_TYPES, KNOWN_TYPES } from './constants';

const FormLine = (props) => {
	const { type, connected, params } = props;

	switch (type) {
		case FORM_LINE_TYPES.textfield:
			return connected ? (
				<TextFieldCFormik {...params} />
			) : (
				<TextField {...params} />
			);
		case FORM_LINE_TYPES.datepicker:
			return connected ? (
				<DatePickerCFormik {...params} />
			) : (
				<DatePicker {...params} />
			);
		case FORM_LINE_TYPES.timepicker:
			return connected ? (
				<TimePickerCFormik {...params} />
			) : (
				<TimePicker {...params} />
			);
		case FORM_LINE_TYPES.select:
			return connected ? <SelectCFormik {...params} /> : <Select {...params} />;
		case FORM_LINE_TYPES.autocomplete:
			return connected ? (
				<AutocompleteCFormik {...params} />
			) : (
				<Autocomplete {...params} />
			);
		case FORM_LINE_TYPES.radio:
			return connected ? (
				<RadioGroupCFormik {...params} />
			) : (
				<RadioGroup {...params} />
			);
		case FORM_LINE_TYPES.checkbox:
			return connected ? (
				<CheckboxGroupCFormik {...params} />
			) : (
				<CheckboxGroup {...params} />
			);
		case FORM_LINE_TYPES.typed:
			return connected ? (
				<TypedFieldCFormik {...params} />
			) : (
				<TypedField {...params} />
			);
		case FORM_LINE_TYPES.upload:
			return connected ? (
				<UploadFieldCFormik {...params} />
			) : (
				<UploadField {...params} />
			);
		case FORM_LINE_TYPES.range:
			return connected ? (
				<RangeFieldCFormik {...params} />
			) : (
				<RangeField {...params} />
			);
		case FORM_LINE_TYPES.custom: {
			const { Component, ...other } = params;
			return Component ? (
				<Component {...other} />
			) : (
				'Custom component required!'
			);
		}
		default:
			return 'Unknown field type!';
	}
};

FormLine.propTypes = {
	type: PropTypes.oneOf(KNOWN_TYPES),
	connected: PropTypes.bool,
	params: PropTypes.oneOfType([
		PropTypes.shape(TextField.propTypes), // FORM_LINE_TYPES.textfield
		PropTypes.shape(DatePicker.propTypes), // FORM_LINE_TYPES.datepicker
		PropTypes.shape(TimePicker.propTypes), // FORM_LINE_TYPES.timepicker
		PropTypes.shape(Select.propTypes), // FORM_LINE_TYPES.select
		PropTypes.shape(Autocomplete.propTypes), // FORM_LINE_TYPES.autocomplete
		PropTypes.shape(RadioGroup.propTypes), // FORM_LINE_TYPES.radio
		PropTypes.shape(CheckboxGroup.propTypes), // FORM_LINE_TYPES.checkbox
		PropTypes.shape(TypedField.propTypes), // FORM_LINE_TYPES.typed
		PropTypes.shape(UploadField.propTypes), // FORM_LINE_TYPES.upload

		// FORM_LINE_TYPES.custom (use for connectors)
		PropTypes.shape({
			Component: PropTypes.elementType,
			data: PropTypes.any,
		}),
	]),
};

export default FormLine;
